import {
  ButtonsModule,
  CpfCnpjModule,
  InputModule,
  PaginationMapsModule,
  TableModule,
} from "maps-angular-components";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from "@angular/core";

import { CommonModule } from "@angular/common";
import { DatepickerModule } from "maps-angular-components";
import { MatTabsModule } from "@angular/material/tabs";
import { PipesModule } from "../shared/pipes/pipes.module";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    InputModule,
    ButtonsModule,
    DatepickerModule,
    PaginationMapsModule,
    TableModule,
    CpfCnpjModule,
    PipesModule,
    MatTabsModule,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HomeModule {}
